import { mfaRequiredEmitter } from '@shipstation/client-common/mfa/mfa-emitter';

import { mfaRequiredSubject } from '../account-verification-needed.subject';

import type { AxiosError, AxiosResponse } from 'axios';

/**
 * Forward legacy MFA-required events onto client-common's emitter.
 *
 * `setup-axios.js` parks the failed request and announces it on
 * `mfaRequiredSubject`, while the client-common provider listens on
 * `mfaRequiredEmitter`. Rather than registering a second axios interceptor —
 * which would race the existing one over the `ss_isMfaRetry` guard and let
 * whichever registered first swallow the event — the single existing
 * interceptor stays authoritative and its output is re-announced here.
 *
 * Only one provider is mounted at a time, so only one side of the bridge has a
 * listener; the unlistened side drops its emission.
 *
 * Delete alongside the legacy provider once the flag reaches 100%.
 */
export const bridgeLegacyMfaRequiredSubject = (): (() => void) => {
  const subscription = mfaRequiredSubject.subscribe((request) => {
    mfaRequiredEmitter.emit({
      config: request.config,
      resolve: (value) => request.resolve(value as AxiosResponse),
      reject: (reason) => request.reject(reason as AxiosError | Error),
      url: request.url,
      method: request.method,
      isNative: request.isNative,
    });
  });

  return () => {
    subscription.unsubscribe();
  };
};
